import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { CheckCircle } from "lucide-react";

const CloudDevOps = () => {
  return (
    <main>

      {/* 🔥 HERO */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(8,20,40,0.85), rgba(8,20,40,0.95)), url('https://images.pexels.com/photos/1181467/pexels-photo-1181467.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "110px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h1 style={{ fontWeight: "700" }}>
            Cloud & DevOps Solutions
          </h1>
          <p style={{ maxWidth: "720px", margin: "auto" }}>
            Build scalable, secure, and automated infrastructure using modern cloud
            platforms and DevOps practices.
          </p>
        </Container>
      </section>

      {/* 🔹 INTRO */}
      <section className="gov-section">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <h2>Modern Infrastructure for Modern Businesses</h2>
              <p>
                We help organizations transition to cloud-native architectures and
                implement DevOps practices that improve deployment speed,
                reliability, and scalability.
              </p>

              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "Faster deployments",
                  "High availability systems",
                  "Reduced infrastructure costs",
                  "Improved system reliability"
                ].map((item, i) => (
                  <li key={i} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="green" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg"
                alt="cloud"
                style={{ width: "100%", borderRadius: "12px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔥 SERVICES */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">Our Cloud & DevOps Services</h2>

          <Row className="g-4">

            {[
              {
                title: "Cloud Migration",
                desc: "Move your applications from on-premise to AWS / Azure."
              },
              {
                title: "CI/CD Pipelines",
                desc: "Automate build, testing, and deployment pipelines."
              },
              {
                title: "Containerization",
                desc: "Dockerize applications for consistency and portability."
              },
              {
                title: "Kubernetes Orchestration",
                desc: "Manage containers at scale with Kubernetes."
              },
              {
                title: "Infrastructure as Code",
                desc: "Automate infrastructure using Terraform / ARM."
              },
              {
                title: "Monitoring & Logging",
                desc: "Real-time system monitoring and performance tracking."
              }
            ].map((item, i) => (
              <Col md={6} lg={4} key={i}>
                <Card className="gov-card p-4 h-100">
                  <h5>{item.title}</h5>
                  <p>{item.desc}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 PROCESS */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.85)), url('https://images.pexels.com/photos/577585/pexels-photo-577585.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "80px 0"
        }}
      >
        <Container>
          <h2 className="text-center mb-5">Our DevOps Approach</h2>

          <Row className="g-4 text-center">
            {[
              "Assessment & Planning",
              "Architecture Design",
              "Automation Setup",
              "Deployment & Integration",
              "Monitoring & Optimization",
              "Continuous Improvement"
            ].map((step, i) => (
              <Col md={4} key={i}>
                <Card className="p-4 bg-dark text-white border-0 h-100">
                  <h5>Step {i + 1}</h5>
                  <p>{step}</p>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* 🔹 TECH STACK */}
      <section className="gov-section">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <h2>Technologies We Use</h2>

              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "AWS / Microsoft Azure",
                  "Docker & Kubernetes",
                  "Terraform & ARM Templates",
                  "GitHub Actions / Azure DevOps",
                  "Linux & Server Administration",
                  "Monitoring Tools (Prometheus, Grafana)"
                ].map((item, i) => (
                  <li key={i} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="green" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3861972/pexels-photo-3861972.jpeg"
                alt="devops"
                style={{ width: "100%", borderRadius: "12px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔥 WHY US */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">Why Choose IGT?</h2>

          <Row className="g-4">

            {[
              "Real DevOps implementation experience",
              "Secure and scalable architectures",
              "Automation-first approach",
              "Cloud cost optimization",
              "Faster deployment cycles",
              "End-to-end support"
            ].map((item, i) => (
              <Col md={4} key={i}>
                <Card className="gov-card p-4 text-center h-100">
                  <p>{item}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 CTA */}
      <section
        style={{
          background: "linear-gradient(135deg, #0d3b66, #1d3557)",
          color: "white",
          padding: "80px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h2>Ready to Scale Your Infrastructure?</h2>
          <p>Let’s modernize your systems with cloud and DevOps.</p>

          <Button href="/contact" size="lg" variant="light">
            Start Now
          </Button>
        </Container>
      </section>

    </main>
  );
};

export default CloudDevOps;